import { useCallback } from 'react';
import { AuthenticatorType, useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export function use2FAEmailCode() {
    const { mutate: getAuthenticatorConfiguration } = useRepositoryMutation('users', 'getAuthenticatorConfiguration');
    const { mutate: apiSendTwoFactorCode } = useRepositoryMutation('users', 'sendTwoFactorCode');
    const { mutate: apiSendTwoFactorLink } = useRepositoryMutation('users', 'sendTwoFactorLink');

    const requestEmailAuthenticatorActivation = useCallback(
        () => getAuthenticatorConfiguration({ authenticator: AuthenticatorType.Email }),
        [getAuthenticatorConfiguration]
    );

    const reRequestEmailAuthenticatorActivation = useCallback(
        () =>
            getAuthenticatorConfiguration(
                { authenticator: AuthenticatorType.Email },
                {
                    onSuccess: showEmailSuccessAlert,
                }
            ),
        [getAuthenticatorConfiguration]
    );

    const sendTwoFactorCode = useCallback(() => {
        apiSendTwoFactorCode(
            {},
            {
                onSuccess: showEmailSuccessAlert,
            }
        );
    }, [apiSendTwoFactorCode]);

    const reSendTwoFactorCode = useCallback(() => {
        apiSendTwoFactorCode({});
    }, [apiSendTwoFactorCode]);

    const sendTwoFactorEmailLink = useCallback(() => {
        apiSendTwoFactorLink(
            {},
            {
                onSuccess: showEmailSuccessAlert,
            }
        );
    }, [apiSendTwoFactorLink]);

    return {
        requestEmailAuthenticatorActivation,
        reRequestEmailAuthenticatorActivation,
        sendTwoFactorCode,
        reSendTwoFactorCode,
        sendTwoFactorEmailLink,
    };
}

const showEmailSuccessAlert = () =>
    showSuccessAlert({ title: lt('EmailSentSuccessfully'), description: lt('CheckYourEmail') });
